import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CheckoutService } from '../stripe/checkout.service';

export interface PlanChangePreviewState {
  loading: boolean;
  loaded: boolean;
  prorationDate: number | null;
}

@Component({
    selector: 'convfact-plan-change-preview',
    templateUrl: './plan-change-preview.component.html',
    styleUrls: ['./plan-change-preview.component.css'],
    standalone: false
})
export class PlanChangePreviewComponent implements OnChanges {

  @Input() planAlias: string;
  @Input() period: string;
  @Input() renewalAmount: number;
  @Output() stateChange = new EventEmitter<PlanChangePreviewState>();

  loading = false;
  loaded = false;
  isDowngrade = false;
  amountDueToday = 0;
  taxToday = 0;
  effectiveDate: Date = null;
  nextRenewalDate: Date = null;
  prorationDate: number | null = null;

  constructor(private checkoutService: CheckoutService) {}

  get periodLabel(): string {
    return this.period === 'year' ? 'año' : 'mes';
  }

  ngOnChanges(): void {
    if (this.planAlias && this.period) {
      this.load();
    }
  }

  private load(): void {
    this.loading = true;
    this.loaded = false;
    this.prorationDate = null;
    Promise.resolve().then(() => this.emitState());

    this.checkoutService.previewPlanChange(this.planAlias, this.period)
      .then(preview => {
        if (!preview) {
          return;
        }
        this.isDowngrade = this.read(preview, 'isDowngrade') === true;
        this.amountDueToday = Number(this.read(preview, 'amountDueToday')) || 0;
        this.taxToday = Number(this.read(preview, 'taxToday')) || 0;
        this.effectiveDate = this.toDate(this.read(preview, 'effectiveDate'));
        this.nextRenewalDate = this.toDate(this.read(preview, 'nextRenewalDate'));
        this.prorationDate = this.read(preview, 'prorationDate') || null;
        this.loaded = true;
      })
      .catch(() => {
        this.loaded = false;
      })
      .finally(() => {
        this.loading = false;
        this.emitState();
      });
  }

  private emitState(): void {
    this.stateChange.emit({
      loading: this.loading,
      loaded: this.loaded,
      prorationDate: this.loaded ? this.prorationDate : null
    });
  }

  private read(source: any, key: string): any {
    const pascal = key.charAt(0).toUpperCase() + key.slice(1);
    return source[key] !== undefined ? source[key] : source[pascal];
  }

  private toDate(value: any): Date {
    return value ? new Date(value) : null;
  }
}
